module.exports = __webpack_public_path__ + "img/1529945153.77ef6e70.jpg";